import { render } from "./Distribution.vue?vue&type=template&id=293994b0&scoped=true"
import script from "./Distribution.vue?vue&type=script&lang=js"
export * from "./Distribution.vue?vue&type=script&lang=js"

import "./Distribution.vue?vue&type=style&index=0&id=293994b0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293994b0"]])

export default __exports__